import { cn } from '@/utils/utils'
import { ReactNode } from 'react'

interface ILabelCreate {
  text: ReactNode
  className?: string
  htmlFor?: string
}

export default function Label({ text, className, htmlFor }: ILabelCreate) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn('mb-2 block text-sm font-semibold text-ui-gray', className)}
    >
      {text}
    </label>
  )
}
